<template>
    <ModalTemplate v-if="users" @close="$store.dispatch('setModalUsers', null)"> 
        <template v-slot:header>
            <h4 class="h4">Поставили лайк</h4>
        </template>
        <template v-slot:body>
            <div class="popup-users">
                <UserMini v-for="user in users" :key="user.id" :user="user" />
            </div>
        </template>

    </ModalTemplate>
</template>
<script>

export default {
    name: 'PopupUsers',
    computed: {
        users() {
            return this.$store.getters.getModalUsers
        }
    },
    components: {
        ModalTemplate: () => import('@/components/Templates/Modal'),
        UserMini: () => import('@/components/Elements/Users/UserMini')
    }
}
</script>
<style lang="stylus">
.popup-users
    display flex
    flex-wrap wrap
    margin-left -10px
    margin-right -10px
</style>